import React from "react";
import { NumericFormat } from "react-number-format";

const TimekeepingConvertHourToDay = ({ hour }) => {
  const days = Math.floor(hour / 8);
  const hourLess = hour % 8;
  return <div>{days > 0 ? <><NumericFormat
    displayType={"text"}
    value={days || 0}
    thousandsGroupStyle="thousand"
    thousandSeparator=","
    decimalScale={2}
  /> ngày <br /> và </> : ''}{<NumericFormat
    displayType={"text"}
    value={hourLess || 0}
    thousandsGroupStyle="thousand"
    thousandSeparator=","
    decimalScale={2}
  />} giờ</div>;
};
export default TimekeepingConvertHourToDay;